import constants from '../constants';

const isChildOfGlobal = (childElement) => Boolean(childElement.closest(constants.GLOBAL_TAG_NAME));

export default isChildOfGlobal;
